import { render, staticRenderFns } from "./OrderActions.vue?vue&type=template&id=af708618&"
import script from "./OrderActions.vue?vue&type=script&lang=js&"
export * from "./OrderActions.vue?vue&type=script&lang=js&"
import style0 from "./OrderActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports